import React, { useEffect, useState } from 'react';

import { Box, Grid, Paper, Snackbar } from '@mui/material';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';

import axios from '../modules/axios';
import { computeParams } from '../utils';
import ActionsButtons from './ActionsButtons';

export default ({
  name,
  resource,
  resourceId,
  edit,
  preProps,
  customUpdate,
  customDelete,
  associations,
  query,
  onEdit,
  remove,
  ...props
}) => {
  const history = useHistory();

  const [data, setData] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    setData(null);

    const params = computeParams({ associations, query });

    axios
      .get(`${resource}/${resourceId}?${params.join('&')}`)
      .then(res => setData(res.data))
      .catch(() => history.push(`/i9/${name}`));
  }, [resource, resourceId, history, associations, query, name]);

  const removeResource = async () => {
    if (customDelete) {
      await customDelete(resourceId);
    } else {
      await axios.delete(`${resource}/${resourceId}`);
    }

    return onEdit ? onEdit() : history.push(`/i9/${name}`);
  };

  const patchResource = async values => {
    if (customUpdate) {
      await customUpdate({ newValues: values, initialValues: data });
    } else {
      await axios.patch(`${resource}/${resourceId}`, values);
    }

    setOpenSnackbar(true);
    if (onEdit) await onEdit();
  };

  return (
    <React.Fragment>
      {data && (
        <Formik initialValues={data} onSubmit={values => patchResource(values)}>
          {({ values, handleChange, handleSubmit, setFieldValue, setFieldTouched, setValues, touched }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container justifyContent='flex-end'>
                <ActionsButtons remove={removeResource} />
              </Grid>
              <Box component={Paper} p={1}>
                <Grid container>
                  {edit &&
                    edit({
                      values,
                      props: {
                        variant: 'outlined',
                        size: 'small',
                        onChange: handleChange,
                        ...props,
                      },
                      preProps,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                      setFieldTouched,
                      setValues,
                      touched,
                      initialValues: data,
                    }).map((f, index) => (
                      <Grid key={index} item xs={12}>
                        <Box p={1}>{f}</Box>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        autoHideDuration={3000}
        message='Enregistré'
      />
    </React.Fragment>
  );
};
